import { __assign, __read } from "tslib";
import { id } from '@slardar/sdk-template';
import { AjaxMonitor } from '../../monitors/ajax';
import { applyMonitor, getLocationUrl } from '../../utils';
import { getPluginConfig } from './utils';
export var AJAX_MONITOR_PLUGIN_NAME = 'ajax';
var defaultConfig = {
    autoWrap: true,
    hookCbAtReq: id,
    ignoreUrls: [],
    collectBodyOnError: false,
};
export var getCbHook = function (client) { return function (cb) {
    if (!cb)
        return cb;
    var clientConfig = client.config();
    var common = {
        url: getLocationUrl(),
        pid: clientConfig.pid,
        view_id: clientConfig.viewId,
    };
    return function (ev) {
        cb(__assign(__assign({}, ev), { overrides: __assign(__assign({}, common), { timestamp: ev.payload.request.timestamp }) }));
    };
}; };
export function AjaxMonitorPlugin(client) {
    client.on('init', function () {
        var config = getPluginConfig(client, AJAX_MONITOR_PLUGIN_NAME, defaultConfig);
        if (!config) {
            return;
        }
        var tearDownFlag = false;
        var tearDown = function () {
            tearDownFlag = true;
        };
        var cb = function (ev) { return !tearDownFlag && client.report(ev); };
        var _a = __read(applyMonitor(AjaxMonitor, __assign(__assign({}, config), { hookCbAtReq: getCbHook(client) }), cb), 1), wrapXhr = _a[0];
        client.on('beforeDestroy', tearDown);
        client.provide('wrapXhr', wrapXhr);
    });
}
//# sourceMappingURL=ajax.js.map